import * as s from "react";
import { c as p } from "./index-DLeNytVF.js";
import { u as _ } from "./index-DLcqcWxM.js";
import { c as V, a as q } from "./index-UFb2E87s.js";
import { u as R } from "./index-umR1UobZ.js";
import { u as K } from "./index-DYfkNB0n.js";
import { D as U } from "./index-Dz0AUfZX.js";
import { R as Y, h as Z, u as z, F as J } from "./index-BUY6qYfp.js";
import { P as Q } from "./index-CsGiVPqA.js";
import { P as h } from "./index-L6dgm95g.js";
import { P as m, c as X } from "./index-BrTLHETv.js";
import { jsx as i, jsxs as N, Fragment as O } from "react/jsx-runtime";
var v = "Dialog", [I, _e] = V(v), [ee, u] = I(v), x = (e) => {
  const {
    __scopeDialog: o,
    children: n,
    open: a,
    defaultOpen: r,
    onOpenChange: t,
    modal: c = !0
  } = e, l = s.useRef(null), d = s.useRef(null), [g, C] = K({
    prop: a,
    defaultProp: r ?? !1,
    onChange: t,
    caller: v
  });
  return /* @__PURE__ */ i(
    ee,
    {
      scope: o,
      triggerRef: l,
      contentRef: d,
      contentId: R(),
      titleId: R(),
      descriptionId: R(),
      open: g,
      onOpenChange: C,
      onOpenToggle: s.useCallback(() => C((H) => !H), [C]),
      modal: c,
      children: n
    }
  );
};
x.displayName = v;
var A = "DialogTrigger", T = s.forwardRef(
  (e, o) => {
    const { __scopeDialog: n, ...a } = e, r = u(A, n), t = _(o, r.triggerRef);
    return /* @__PURE__ */ i(
      m.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": y(r.open),
        ...a,
        ref: t,
        onClick: p(e.onClick, r.onOpenToggle)
      }
    );
  }
);
T.displayName = A;
var P = "DialogPortal", [te, b] = I(P, {
  forceMount: void 0
}), M = (e) => {
  const { __scopeDialog: o, forceMount: n, children: a, container: r } = e, t = u(P, o);
  return /* @__PURE__ */ i(te, { scope: o, forceMount: n, children: s.Children.map(a, (c) => /* @__PURE__ */ i(h, { present: n || t.open, children: /* @__PURE__ */ i(Q, { asChild: !0, container: r, children: c }) })) });
};
M.displayName = P;
var D = "DialogOverlay", w = s.forwardRef(
  (e, o) => {
    const n = b(D, e.__scopeDialog), { forceMount: a = n.forceMount, ...r } = e, t = u(D, e.__scopeDialog);
    return t.modal ? /* @__PURE__ */ i(h, { present: a || t.open, children: /* @__PURE__ */ i(re, { ...r, ref: o }) }) : null;
  }
);
w.displayName = D;
var oe = X("DialogOverlay.RemoveScroll"), re = s.forwardRef(
  (e, o) => {
    const { __scopeDialog: n, ...a } = e, r = u(D, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ i(Y, { as: oe, allowPinchZoom: !0, shards: [r.contentRef], children: /* @__PURE__ */ i(
        m.div,
        {
          "data-state": y(r.open),
          ...a,
          ref: o,
          style: { pointerEvents: "auto", ...a.style }
        }
      ) })
    );
  }
), f = "DialogContent", F = s.forwardRef(
  (e, o) => {
    const n = b(f, e.__scopeDialog), { forceMount: a = n.forceMount, ...r } = e, t = u(f, e.__scopeDialog);
    return /* @__PURE__ */ i(h, { present: a || t.open, children: t.modal ? /* @__PURE__ */ i(ne, { ...r, ref: o }) : /* @__PURE__ */ i(ae, { ...r, ref: o }) });
  }
);
F.displayName = f;
var ne = s.forwardRef(
  (e, o) => {
    const n = u(f, e.__scopeDialog), a = s.useRef(null), r = _(o, n.contentRef, a);
    return s.useEffect(() => {
      const t = a.current;
      if (t) return Z(t);
    }, []), /* @__PURE__ */ i(
      S,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: p(e.onCloseAutoFocus, (t) => {
          var c;
          t.preventDefault(), (c = n.triggerRef.current) == null || c.focus();
        }),
        onPointerDownOutside: p(e.onPointerDownOutside, (t) => {
          const c = t.detail.originalEvent, l = c.button === 0 && c.ctrlKey === !0;
          (c.button === 2 || l) && t.preventDefault();
        }),
        onFocusOutside: p(
          e.onFocusOutside,
          (t) => t.preventDefault()
        )
      }
    );
  }
), ae = s.forwardRef(
  (e, o) => {
    const n = u(f, e.__scopeDialog), a = s.useRef(!1), r = s.useRef(!1);
    return /* @__PURE__ */ i(
      S,
      {
        ...e,
        ref: o,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (t) => {
          var c, l;
          (c = e.onCloseAutoFocus) == null || c.call(e, t), t.defaultPrevented || (a.current || (l = n.triggerRef.current) == null || l.focus(), t.preventDefault()), a.current = !1, r.current = !1;
        },
        onInteractOutside: (t) => {
          var d, g;
          (d = e.onInteractOutside) == null || d.call(e, t), t.defaultPrevented || (a.current = !0, t.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const c = t.target;
          ((g = n.triggerRef.current) == null ? void 0 : g.contains(c)) && t.preventDefault(), t.detail.originalEvent.type === "focusin" && r.current && t.preventDefault();
        }
      }
    );
  }
), S = s.forwardRef(
  (e, o) => {
    const { __scopeDialog: n, trapFocus: a, onOpenAutoFocus: r, onCloseAutoFocus: t, ...c } = e, l = u(f, n), d = s.useRef(null), g = _(o, d);
    return z(), /* @__PURE__ */ N(O, { children: [
      /* @__PURE__ */ i(
        J,
        {
          asChild: !0,
          loop: !0,
          trapped: a,
          onMountAutoFocus: r,
          onUnmountAutoFocus: t,
          children: /* @__PURE__ */ i(
            U,
            {
              role: "dialog",
              id: l.contentId,
              "aria-describedby": l.descriptionId,
              "aria-labelledby": l.titleId,
              "data-state": y(l.open),
              ...c,
              ref: g,
              onDismiss: () => l.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ N(O, { children: [
        /* @__PURE__ */ i(ie, { titleId: l.titleId }),
        /* @__PURE__ */ i(ce, { contentRef: d, descriptionId: l.descriptionId })
      ] })
    ] });
  }
), E = "DialogTitle", W = s.forwardRef(
  (e, o) => {
    const { __scopeDialog: n, ...a } = e, r = u(E, n);
    return /* @__PURE__ */ i(m.h2, { id: r.titleId, ...a, ref: o });
  }
);
W.displayName = E;
var k = "DialogDescription", G = s.forwardRef(
  (e, o) => {
    const { __scopeDialog: n, ...a } = e, r = u(k, n);
    return /* @__PURE__ */ i(m.p, { id: r.descriptionId, ...a, ref: o });
  }
);
G.displayName = k;
var L = "DialogClose", $ = s.forwardRef(
  (e, o) => {
    const { __scopeDialog: n, ...a } = e, r = u(L, n);
    return /* @__PURE__ */ i(
      m.button,
      {
        type: "button",
        ...a,
        ref: o,
        onClick: p(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
$.displayName = L;
function y(e) {
  return e ? "open" : "closed";
}
var B = "DialogTitleWarning", [he, j] = q(B, {
  contentName: f,
  titleName: E,
  docsSlug: "dialog"
}), ie = ({ titleId: e }) => {
  const o = j(B), n = `\`${o.contentName}\` requires a \`${o.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${o.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${o.docsSlug}`;
  return s.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, se = "DialogDescriptionWarning", ce = ({ contentRef: e, descriptionId: o }) => {
  const a = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${j(se).contentName}}.`;
  return s.useEffect(() => {
    var t;
    const r = (t = e.current) == null ? void 0 : t.getAttribute("aria-describedby");
    o && r && (document.getElementById(o) || console.warn(a));
  }, [a, e, o]), null;
}, Pe = x, Ee = T, ye = M, Ne = w, Oe = F, Ie = W, xe = G, Ae = $;
export {
  Oe as C,
  xe as D,
  Ne as O,
  ye as P,
  Pe as R,
  Ie as T,
  Ae as a,
  Ee as b
};
//# sourceMappingURL=index-Bxq-rK0V.js.map
